exports = module.exports = require("../../../../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".banner-tabs[data-v-af49fc98] {\n  width: 100%;\n  margin-bottom: 20px;\n}\n.upload-tip[data-v-af49fc98] {\n  color: #f56c6c;\n  font-size: 12px;\n  margin-top: 5px;\n}\n.form-tip[data-v-af49fc98] {\n  font-size: 12px;\n  color: red;\n  line-height: 1.5;\n  margin-left: 10px;\n}", ""]);

// exports
